var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"th-custom-clinro-history"},[_c('div',{directives:[{name:"translate",rawName:"v-translate:_formattedInformation",value:({
      key: _vm.instructionScreen.id,
      val: _vm.lang,
      html: _vm.instructionScreen.formattedInformation
    }),expression:"{\n      key: instructionScreen.id,\n      val: lang,\n      html: instructionScreen.formattedInformation\n    }",arg:"_formattedInformation"}],domProps:{"innerHTML":_vm._s(_vm.instructionScreen.formattedInformation)}})])}
var staticRenderFns = []

export { render, staticRenderFns }